export default {"src":"/_next/static/media/earn_cash_back.8120c7bb.svg","height":387,"width":486};